export const CROSS_SELL_PRODUCTS = 'crossSellProducts';
export const UP_SELL_PRODUCTS = 'upSellProducts';

export const HOME_PATH_OPTIONS = [CROSS_SELL_PRODUCTS];
